import { ref, watchEffect } from "vue";
import { u as useResizeObserver } from "./useResizeObserver.js";
const useElementWidth = (el) => {
  const width = ref(null);
  useResizeObserver([el], () => {
    var _a;
    width.value = ((_a = el.value) == null ? void 0 : _a.clientWidth) ?? null;
  });
  watchEffect(() => {
    var _a;
    width.value = ((_a = el.value) == null ? void 0 : _a.clientWidth) ?? null;
  });
  return width;
};
export {
  useElementWidth as u
};
//# sourceMappingURL=useElementWidth.js.map
